/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';

import { Container } from './styles';

export default function ImageView(props) {
  ImageView.propTypes = {
    title: PropTypes.string,
    src: PropTypes.string,
    visible: PropTypes.bool,
    setVisible: PropTypes.func,
  };

  ImageView.defaultProps = {
    title: '',
  };

  const { title, src, visible, setVisible } = props;

  return (
    <Container>
      <Dialog
        closable
        closeOnEscape
        header={title}
        visible={visible}
        contentStyle={{ margin: 0, padding: 0 }}
        style={{ minWidth: '350px' }}
        modal
        blockScroll
        onHide={() => {
          if (setVisible) {
            setVisible(false);
          }
        }}
      >
        <img
          src={src}
          frameBorder="0"
          scrolling="auto"
          style={{ maxWidth: 1024 }}
          className="responsive"
        />
      </Dialog>
    </Container>
  );
}
